import { GqlDispensaries } from 'types/graphql';
import { Filter } from 'src/services/xminds';

export const getDispensaryFilter = (dispensary: GqlDispensaries): Filter => ({
  // eslint-disable-next-line @typescript-eslint/naming-convention
  property_name: `dispensary_id`,
  op: `eq`,
  value: dispensary.id ?? '',
});
